import { useState } from 'react';
import { ButtonSection, Link } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { DocumentSelectorModal } from '@frontend/document-selector-modal';
import { useCombinedDocumentsListV3 } from '@frontend/documents-hooks';
import { useModalControl } from '@frontend/design-system';
import { useComposerSection } from '../../../hooks';
import { useContentComposer } from '../../content-composer-provider';
import {
  CustomLinkToolbar,
  DefaultButtonToolbar,
  FloatingToolbarCenter,
  LinkOptionsToolbar,
  SelectedLinkToolbar,
} from '.';

type Props = {
  link?: Link;
};

export const ButtonsToolbar = ({ link }: Props) => {
  const [showOptions, setShowOptions] = useState(!!link?.url || !!link?.linkType);
  const [showCustom, setShowCustom] = useState(false);
  const { setProps } = useComposerSection<ButtonSection>();
  const { form, locationIds, setForm } = useContentComposer();

  const updateLink = (newLink: Link) => {
    setProps((props) => (props.link = newLink));
  };

  // FORM
  const documents = useCombinedDocumentsListV3(locationIds);
  const { modalProps, triggerProps } = useModalControl();
  const openDocumentSelectorModal = () => {
    triggerProps.onClick();
  };
  const updateDocumentId = (documentId: string) => {
    updateLink({ ...link, url: documentId, linkType: 'form' });
    const documentType = documents?.find((form) => form.id === documentId)?.documentType ?? 'form';
    setForm?.({ documentId, documentType });
    modalProps.onClose();
  };

  // CUSTOM LINK TOOLBAR
  const handleCustomLinkInput = (newLink: Link) => {
    updateLink(newLink);
    setShowCustom(false);
  };

  // SELECTED LINK TOOLBAR
  const handleSelectedLinkClick = () => {
    if (link?.linkType === 'form') {
      openDocumentSelectorModal();
    } else if (link?.linkType === 'custom') {
      setShowCustom(true);
    }
  };

  const handleRemoveLink = () => {
    updateLink({ ...link, url: '', linkType: '' });
    setShowCustom(false);
  };

  const getContent = () => {
    if (!showOptions) return <DefaultButtonToolbar onClick={() => setShowOptions(true)} />;
    else if (showCustom)
      return <CustomLinkToolbar handleSubmit={handleCustomLinkInput} link={link} setShow={setShowCustom} />;
    else if (link?.url && !showCustom)
      return (
        <SelectedLinkToolbar
          documents={documents}
          link={link}
          onClick={handleSelectedLinkClick}
          removeLink={handleRemoveLink}
        />
      );
    return (
      <LinkOptionsToolbar
        link={link}
        onClick={updateLink}
        openModal={openDocumentSelectorModal}
        setShow={setShowOptions}
        setShowCustom={setShowCustom}
      />
    );
  };

  return (
    <>
      <FloatingToolbarCenter orientation='bottom' css={{ left: '50%' }} honorX>
        {getContent()}
      </FloatingToolbarCenter>
      <DocumentSelectorModal
        modalProps={modalProps}
        documents={documents}
        documentId={form?.documentId}
        updateDocumentId={updateDocumentId}
      />
    </>
  );
};
